import events from './events'
import store from 'reducers'
import Actions from './Actions'
import dayjs from 'lib/helpers/dayjs';

import { isOrganizationIntegrated  } from 'lib/helpers';

import { 
    SessionActions, 
    ClassificationActions,
    BreedActions,
    AppointmentTypeActions,
    GenderActions,
    AdministratorActions,
    FilterActions,
    PageActions,
    LoadingActions,
    CustomFieldActions
} from 'actions'

export default class OrganizationActions extends Actions{
    static get target(){
        return 'organization'
    }

    static findByID(organizationID, startingAt, endingAt){
        let resData = {}
        LoadingActions.append({organization: true})
        return this.client.organizations.findByID(organizationID, startingAt, endingAt).then((response)=>{
            if(!response.data.error){
                resData = response
                return
            } else {
                SessionActions.clear()
                PageActions.reset()

                return this.findByID(organizationID, startingAt, endingAt)
            }
        }).then((response)=>{
            if(response && !response.data.error){
                resData = response
            }

            let data = {
                ...(store.getState().config.initialState || {})
            }

            let integratedWhiteList = ['appointmentTypes','administrators']
            for(let key of Object.keys(resData.data)){
                if(Array.isArray(resData.data[key])){
                    data[key] = {}
                    let _data = resData.data[key]
                    if(isOrganizationIntegrated(resData.data.organization)){
                        _data = _data.filter((data)=>{
                            if(integratedWhiteList.includes(key)){
                                if(data.integrationID){
                                    return true
                                }
                                return false
                            }
                            return true
                        })
                    } 
                    for(let value of _data){
                        data[key][value.id] = value
                    }
                } else {
                    data[key] = resData.data[key]
                }
            }
            
            data.filters = {availabilitiesReceived: [], startDate: dayjs().format()}

            this.set(data.organization)
            AppointmentTypeActions.set(data.appointmentTypes)
            AdministratorActions.set(data.administrators)
            FilterActions.set(data.filters)
            CustomFieldActions.set(data.customFields)

            LoadingActions.append({organization: false})
            return resData
        })
    }

    static findPatientDataByID(organizationID){

        if(store.getState().loading.patientData){
            return
        }
        
        let resData = {}
        LoadingActions.append({patientData: true})
        return this.client.organizations.findPatientDataByID(organizationID).then((response)=>{
            if(response && !response.data.error){
                resData = response
            }

            let data = {
                ...(store.getState().config.initialState || {})
            }

            let integratedWhiteList = ['breeds','classifications','genders']
            for(let key of Object.keys(resData.data)){
                if(Array.isArray(resData.data[key])){
                    data[key] = {}
                    let _data = resData.data[key]
                    if(isOrganizationIntegrated(store.getState().organization)){
                        _data = _data.filter((data)=>{
                            if(integratedWhiteList.includes(key)){
                                if(data.integrationID){
                                    return true
                                }
                                return false
                            }
                            return true
                        })
                    } 
                    for(let value of _data){
                        data[key][value.id] = value
                    }
                } else {
                    data[key] = resData.data[key]
                }
            }

            ClassificationActions.set(data.classifications)
            BreedActions.set(data.breeds)
            GenderActions.set(data.genders)

            LoadingActions.append({patientData: false})
            return resData
        })
    }

    static refreshSync(){
        return this.client.organizations.refreshSync()
    }
}


// WEBPACK FOOTER //
// ./actions/OrganizationActions.js